import styles from '../../pages/portal/PortalInboxPage.module.css';

export type ImportantReadState = 'all' | 'unread' | 'read';

interface ImportantSubFilterProps {
  value: ImportantReadState;
  onChange: (next: ImportantReadState) => void;
  /** Total Important emails (matches the parent tab pill). */
  totalCount: number;
  /** Important emails where the Gmail UNREAD label is set. */
  unreadCount: number;
  /** Important emails where the Gmail UNREAD label is absent. */
  readCount: number;
}

interface PillOption {
  id: ImportantReadState;
  label: string;
  count: number;
}

const ImportantSubFilter: React.FC<ImportantSubFilterProps> = ({
  value,
  onChange,
  totalCount,
  unreadCount,
  readCount,
}) => {
  const options: PillOption[] = [
    { id: 'all', label: 'All', count: totalCount },
    { id: 'unread', label: 'Unread', count: unreadCount },
    { id: 'read', label: 'Read', count: readCount },
  ];

  return (
    <div
      className={styles.subFilterPills}
      role="tablist"
      aria-label="Filter Important by read state"
    >
      {options.map((opt) => {
        const active = opt.id === value;
        return (
          <button
            key={opt.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${styles.subFilterPill} ${active ? styles.subFilterPillActive : ''}`}
            onClick={() => onChange(opt.id)}
          >
            {opt.label}
            <span className={styles.subFilterPillCount}>{opt.count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ImportantSubFilter;
